import * as React from 'react';
import WebChatBot from './chatbot';
import { getLanguage } from '../../utilities/language';
import IChatbotProps from '../Interface/IChatbotProps';

export interface IChatbotselectorComponentProps {
    chatbotsettings: IChatbotProps
}

interface HideAndShowChatProp {
    hideHowChatDiv: boolean;
}
const selectedLanguage = getLanguage();

export class Chatbotselector extends React.Component<IChatbotselectorComponentProps> {
    state: HideAndShowChatProp = {
        hideHowChatDiv: false
    };

    toggle = () => {
        this.setState(() => ({ hideHowChatDiv: !this.state.hideHowChatDiv }))

        var datee = new Date();

        var date = datee + " milliseconds-" + datee.getMilliseconds();

        localStorage.setItem('Response start time', date);
    };
    
onkeydown = e => {
    
    if (e.key == 'Enter') {
        this.setState(() => ({ hideHowChatDiv: true }))
    }
    if (e.key == 'Escape') {
        this.setState(() => ({ hideHowChatDiv: false }))
    }
}
    render() {
        return (
            <div>
                {this.state.hideHowChatDiv ? <div id='webchat'>
                    <WebChatBot language={selectedLanguage} toggleFn={this.toggle} chatbotsettings={this.props.chatbotsettings}></WebChatBot>
                </div> : ''}
                <div className="d-hotline h-btn animated zoomIn faster" onClick={this.toggle} onKeyDown={this.onkeydown}>
                    <div className="chat-content" aria-label="Chat" tabIndex={0} role="button" title="Chat">
                        <i className="icon-ic_chat_icon"></i>
                    </div>
                    <div className=" ">
                        <span aria-hidden="true" tabIndex={-1}>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}
export default Chatbotselector;
